import { styled } from '@mui/material/styles';

export const MapContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}));
